import { useEffect } from "react";

// Reveals .reveal-on-scroll elements as they enter the viewport.
// Robust against async-loaded content and route changes, with a safety fallback.
export function useReveal(dep) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const revealAll = () => document.querySelectorAll(".reveal-on-scroll:not(.is-visible)").forEach((e) => e.classList.add("is-visible"));
    if (reduce || !("IntersectionObserver" in window)) { revealAll(); return; }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-visible"); io.unobserve(entry.target); }
      });
    }, { threshold: 0.05, rootMargin: "0px 0px -40px 0px" });

    const observeNew = () => document.querySelectorAll(".reveal-on-scroll:not(.is-visible)").forEach((e) => io.observe(e));
    observeNew();

    const mo = new MutationObserver(() => observeNew());
    mo.observe(document.body, { childList: true, subtree: true });

    // Safety: never leave content hidden if the observer misses it.
    const t = setTimeout(revealAll, 1200);
    return () => { io.disconnect(); mo.disconnect(); clearTimeout(t); };
  }, [dep]);
}
